import type { ComponentProps } from 'react'

import GooglePlaceRatingDisplay from './GooglePlaceRatingDisplay'

import { usePlaceRating } from 'tripPlanner/hooks/Google/usePlaceRating'

interface Props
  extends Omit<
    ComponentProps<typeof GooglePlaceRatingDisplay>,
    'rating' | 'ratingsCount'
  > {
  placeId: string
}

function GooglePlaceRating(props: Props) {
  const { placeId, ...rest } = props
  const { data: place, isLoading } = usePlaceRating(placeId)

  if (isLoading || !place) return null
  const { rating, userRatingCount } = place
  if (!rating) return null

  return (
    <GooglePlaceRatingDisplay
      rating={rating}
      ratingsCount={userRatingCount}
      {...rest}
    />
  )
}

export default GooglePlaceRating
